import { likeMetaStore } from '../store/LikeStore';

export function visiblitySubscribe() {
  const handleViewEvent = () => {
    if (document.visibilityState === 'hidden') {
      const likeMeta = likeMetaStore.getState();
      for (const id in likeMeta) {
        const meta = likeMeta[id];
        // is_saved_product가 있었던 항목들은 hidden 시 API 호출 가능하도록 설정
        if (meta.shouldSkipApiCall && meta.wasInitializedWithSavedProduct) {
          likeMeta[id] = {
            ...meta,
            shouldSkipApiCall: false, // API 호출 활성화
            has: true, // API 호출 대상으로 설정
            inView: true, // 화면에 보이는 상태로 설정
          };
        } else if (!meta.shouldSkipApiCall) {
          // 기존 로직 유지
          likeMeta[id] = { ...meta, has: true };
        }
      }
    }
    if (document.visibilityState === 'visible') {
      const likeMeta = likeMetaStore.getState();
      const newState: typeof likeMeta = {};

      // shouldSkipApiCall이 true인 항목들은 유지하고, 나머지만 초기화
      for (const id in likeMeta) {
        // is_saved_product로 초기화된 항목이지만 이미 hidden을 거친 경우는 유지
        if (
          likeMeta[id].shouldSkipApiCall ||
          (likeMeta[id].wasInitializedWithSavedProduct && !likeMeta[id].shouldSkipApiCall)
        ) {
          newState[id] = likeMeta[id];
        }
      }

      likeMetaStore.setState(newState);
    }
  };
  document.addEventListener('visibilitychange', handleViewEvent);
  return () => document.removeEventListener('visibilitychange', handleViewEvent);
}
